var slotRootStyle = 'fx_2d2fb1e5_1ucncm00';

export { slotRootStyle };
//# sourceMappingURL=layout.vanilla.mjs.map
